<template>
  <div class="dx-spinner" v-if="active">
    <div class="dx-spinner__bar"></div>
    <div class="dx-spinner__background"></div>
  </div>
</template>

<script>
export default {
  name: 'dx-spinner',
  props: {
    active: Boolean
  }
}
</script>



// WEBPACK FOOTER //
// src/components/DxSpinner.vue